import { render, staticRenderFns } from "./GiftGoalSettingsContent.vue?vue&type=template&id=2d056360"
import script from "./GiftGoalSettingsContent.vue?vue&type=script&lang=js"
export * from "./GiftGoalSettingsContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports